import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { motion } from 'framer-motion';
import { School, Edit, Trash2, Copy, CheckCircle, MessageSquare } from 'lucide-react';
import { useLanguage } from '@/i18n/LanguageContext';

export const ClassCard = ({ cls, index, copiedCode, onCopyCode, onMessage, onEdit, onDelete }) => {
  const { t } = useLanguage();
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: index * 0.05 }}
    >
      <Card className="bg-card border-border card-hover">
        <CardContent className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 bg-primary/10 rounded-sm flex items-center justify-center">
              <School className="w-6 h-6 text-primary" />
            </div>
            <div className="flex gap-1">
              <Button
                variant="ghost" size="icon"
                onClick={() => onMessage(cls)}
                className="h-8 w-8 text-muted-foreground hover:text-primary"
                title={t('admin.sendMessage')}
                data-testid={`message-class-${cls.class_id}`}
              >
                <MessageSquare className="w-4 h-4" />
              </Button>
              <Button variant="ghost" size="icon" onClick={() => onEdit(cls)} className="h-8 w-8">
                <Edit className="w-4 h-4" />
              </Button>
              <Button
                variant="ghost" size="icon"
                onClick={() => onDelete(cls.class_id)}
                className="h-8 w-8 text-destructive hover:text-destructive"
              >
                <Trash2 className="w-4 h-4" />
              </Button>
            </div>
          </div>

          <h3 className="text-xl font-bold mb-1">{cls.name}</h3>
          <p className="text-sm text-muted-foreground mb-2">{cls.school_name}</p>
          <div className="flex items-center justify-between">
            <p className="text-xs font-mono text-primary">{cls.year}</p>
            {cls.teacher_code && (
              <button
                onClick={(e) => { e.stopPropagation(); onCopyCode(cls); }}
                className="flex items-center gap-1.5 text-xs font-mono bg-muted px-2 py-1 rounded-sm hover:bg-muted/80 transition-colors"
                title={t('admin.teacherCode')}
                data-testid={`copy-teacher-code-${cls.class_id}`}
              >
                {copiedCode === cls.class_id ? (
                  <CheckCircle className="w-3 h-3 text-green-500" />
                ) : (
                  <Copy className="w-3 h-3 text-muted-foreground" />
                )}
                <span className="text-muted-foreground">{cls.teacher_code}</span>
              </button>
            )}
          </div>
        </CardContent>
      </Card>
    </motion.div>
  );
};
